var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "col" }, [
      _c(
        "h4",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.trans.title_convert) },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col mt-4" }, [
      _c("ul", { staticClass: "list-group" }, [
        _c(
          "li",
          {
            staticClass:
              "list-group-item d-flex justify-content-between align-items-center",
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.trans.voucher) +
                "\n                "
            ),
            _c("span", [_c("b", [_vm._v(_vm._s(_vm.voucher))])]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "list-group-item d-flex justify-content-between align-items-center",
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.trans.credits) +
                "\n                "
            ),
            _c("span", [_c("b", [_vm._v(_vm._s(_vm.voucherCredits))])]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col mt-4" }, [
        _c(
          "button",
          { staticClass: "btn btn-primary", on: { click: _vm.redeemVoucher } },
          [_vm._v(_vm._s(_vm.trans.convert))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }